module.exports = __webpack_public_path__ + "static/media/side_2.d61f1571.png";